<template>
  <breadcrumb>
    <breadcrumb-item :active="$route.name === 'cart'">
      <router-link class="main-link" :to="{ name: 'cart' }">
        Cart
      </router-link>
    </breadcrumb-item>
    <breadcrumb-item :active="$route.name === 'information'">
      <router-link class="main-link" :to="{ name: 'information' }">
        Information
      </router-link>
    </breadcrumb-item>
    <breadcrumb-item
      v-if="deliveryMethod === 'shipping'"
      :active="$route.name === 'shipping'"
    >
      <router-link class="main-link" :to="{ name: 'shipping' }">
        Shipping
      </router-link>
    </breadcrumb-item>
    <breadcrumb-item :active="$route.name === 'payment'">
      <router-link class="main-link" :to="{ name: 'payment' }">
        Payment
      </router-link>
    </breadcrumb-item>
  </breadcrumb>
</template>

<script>
import Breadcrumb from "./Breadcrumb";
import BreadcrumbItem from "./BreadcrumbItem";

export default {
  components: {
    Breadcrumb,
    BreadcrumbItem
  },
  computed: {
    deliveryMethod() {
      return this.$store.state.checkout.deliveryMethod;
    }
  }
};
</script>

<style></style>
